<template>
    <rkm-table
        :fields="fields"
        :items="data"
        sort-by="nomeFantasia"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                :disabled="!item.allowDestroy && !!item.id"
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>

export default {
    data: () => ({
        fields: [
            { key: 'nomeFantasia', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(prestador) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir prestador?',
                async () => {this.data.splice(this.data.indexOf(prestador), 1)}
            )
        },
    },
    props: {
        data: { type: [Array, Object], required: true },
    },
}
</script>